// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1945":"541bbdeb09909f10","3877":"fe336940f98fdfab","4213":"cae3107f98b45a3b","6272":"aa4472f7082b94cd"}[chunkId] + ".css";
};